module.exports = __webpack_public_path__ + "static/media/Assorted pics harves 002.dd125f85.jpg";